// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
};
class AjaxCart extends HTMLElement {
    constructor() {
      super();
  
      this.openeBy = drawerSelectors.cartIcons;
      this.isOpen =  this.classList.contains('open--drawer');
      this.bindEvents();
      this.cartNoteInput();
      this.querySelectorAll('.close-ajax--cart').forEach(button => button.addEventListener('click', this.closeCartDrawer.bind(this)));
      
      if(window.hasOwnProperty('globalVariables') && window.globalVariables.template != 'cart'){
        this.addAccessibilityAttributes(this.openeBy);
        this.getCartData();
      }else{
        this.style.visibility = 'visible';
        if(window.globalVariables?.cart.item_count > 0 && window.globalVariables?.cart.total_price <= 0){
          window.location.href="/cart/clear"
        }
        const found_gwp = window.globalVariables?.cart.items.find((item) => item.properties['_GWP']);
        if(found_gwp && found_gwp.quantity > 1){
          this._updateGWP(found_gwp.id , 1)
        }

        const found_complementary = window.globalVariables?.cart.items.find((item) => item.properties['_isComplimentary']);
        if(found_complementary && found_complementary.quantity > 1){
          this._updateGWP(found_complementary.id , 1)
        }
      }

      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
  
    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }
  
    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, _oldValue, newValue) {
      // called when one of attributes listed above is modified
      if(name == 'updating' && newValue == 'false'){
        this.updateEvents();
      }
    }
  
    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
      let _this = this;
      openDrawerButtons.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', _this.id);
      });
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      this.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
  
    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
      if(window.hasOwnProperty('globalVariables')&&window.globalVariables.template != 'cart'){
        this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }
      this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents(){
      this.querySelectorAll('[data-itemRemove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
      this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
      this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', this.onQtyChange.bind(this)));
    }
  
    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
      if(!window.globalVariables.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
       this.getCartData();
  
      if(document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      }
  
      this.classList.add('opened-drawer');
      siteOverlay.prototype.showOverlay();
      Utility.forceFocus(this.querySelector('.cart-title'));
      let closeBtn = this.querySelector('.close-ajax--cart');
      Utility.trapFocus(this, closeBtn);
  
      if(event){
        event.preventDefault();
        let openBy = event.currentTarget;
        openBy.setAttribute('aria-expanded', true);
      }
    }
  
    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        event.preventDefault();
        this.classList.remove('opened-drawer');
        siteOverlay.prototype.hideOverlay();
        let openByEle = event.currentTarget;
        openByEle.setAttribute('aria-expanded', false);
        Utility.removeTrapFocus(elementToFocus);
  
        let actionBtn = drawerSelectors.cartIconDesktop;
        if(window.innerWidth < 1024){
          actionBtn = drawerSelectors.cartIconMobile;
        }
        Utility.forceFocus(actionBtn);
      }
    }
  
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action){
      this.setAttribute('updating', true);
      // Convert the HTML string into a document object
      let cartHTML = '';
      if(window.globalVariables.template != 'cart') {
        cartHTML = response['template-cart-drawer'];
      }else{
        cartHTML = response['template-cart'];
      }

      if(cartHTML == null) return;
      let parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
      if(cartJSONEle != undefined && cartJSONEle != null){
        window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
      }
      
      let cartElement, gwpElement;
    if (window.globalVariables.template == 'cart') {
      cartElement = cartHTML.querySelector('ajax-cart [data-cart-form]');
      this.querySelector('[data-cart-form]').innerHTML = cartElement.innerHTML;
      gwpElement = cartHTML.querySelector('yonka-gwp');
      if(gwpElement) {
          this.querySelector('yonka-gwp').replaceWith(gwpElement);
      }
    }else{
       cartElement = cartHTML.querySelector('ajax-cart form');
      this.querySelector('form').innerHTML = cartElement.innerHTML;
       gwpElement = cartHTML.querySelector('yonka-gwp');
       if(gwpElement) {
           this.querySelector('yonka-gwp').replaceWith(gwpElement);
       }
    }

     
      this.querySelector('[data-carttotal] span.money').innerHTML = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
      if (window.globalVariables.template == 'cart') {
       this.querySelector('[data-sub-total]').innerHTML = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
      }

      let elements = this.querySelectorAll('[data-checkoutBtns], [data-cartnote], [data-cartupsell] ,[save-for-letter]');
      if(window.globalVariables.cart.item_count <= 0){
        elements.forEach((div)=>{
          div.classList.add('d-none');
        });
      }else{
        elements.forEach((div)=>{
          div.classList.remove('d-none');
        });
      }
      this.setAttribute('updating', false);

      let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
      let cartIcon = headerHTML.getElementById('cart-icon-desktop');
      if(drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
      if(drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;
      
      if(window.globalVariables.cart_drawer && action == 'open_drawer' && window.globalVariables.template != 'cart'){
          this.openCartDrawer();
      }
     
        this.manageComKit();
      // if (window.globalVariables.template =='cart') {
      //     if (localStorage.discountCode != undefined) {
      //     templateCartJS.prototype.applyDiscount(JSON.parse(localStorage.discountCode).code);
      //     }
      //  }
        let  totalPrice = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
        totalPrice = totalPrice.replace("$","");
        totalPrice = totalPrice.replace("£","");
        totalPrice = parseFloat(totalPrice);
        let  freeShipping   = parseFloat(window.globalVariables.free_shipping);
        let  freeTrial   = parseFloat(window.globalVariables.free_trial);
        // Detect language from URL
        let lang = 'en';
        if (window.location.pathname.startsWith('/fr')) {
          lang = 'fr';
        } else if (window.location.pathname.startsWith('/de')) {
          lang = 'de';
        }

        // Translation strings
        const translations = {
          en: {
            away: (amount) => `You are ${amount}€ away from free shipping!`,
            qualifies: "Your order qualifies for FREE shipping!",
            freeShippingAtCheckout: "Free Shipping at Checkout",
            shippingAtCheckout: "Shipping at Checkout"
          },
          fr: {
            away: (amount) => `Plus que ${amount}€ d’achat pour bénéficier de la livraison gratuite!`,
            qualifies: "Votre commande bénéficie de la LIVRAISON GRATUITE !",
            freeShippingAtCheckout: "Livraison gratuite à la caisse",
            shippingAtCheckout: "Livraison à la caisse"
          },
          de: {
            away: (amount) => `Nur noch ${amount}€ bis zum kostenlosen Versand!`,
            qualifies: "Ihre Bestellung qualifiziert sich für KOSTENLOSEN Versand!",
            freeShippingAtCheckout: "Kostenloser Versand an der Kasse",
            shippingAtCheckout: "Versand an der Kasse"
          }
        };

        // Use translation
        if (freeShipping > totalPrice) {
          let amount = (freeShipping - totalPrice).toFixed(2);
          if(document.querySelector("[data-left-amount]") != null){
            document.querySelector("[data-left-amount]").innerHTML = translations[lang].away(amount);
          }
        } else {
          if(document.querySelector("[data-left-amount]") != null) {
            document.querySelector("[data-left-amount]").innerHTML = translations[lang].qualifies;
          } 
        }
        if(totalPrice > freeShipping){
          if(document.querySelector("[cart-drawer-free-shipping]") != null){
            document.querySelector("[cart-drawer-free-shipping]").innerHTML = translations[lang].freeShippingAtCheckout;
          }
        } else {
          if(document.querySelector("[cart-drawer-free-shipping]") != null){
            document.querySelector("[cart-drawer-free-shipping]").innerHTML = translations[lang].shippingAtCheckout;
          }
        }
        
        const productRecommendationComponent = document.querySelector('.cart-recommendations .product-recommendations');
        try{
          loadRecommendedProducts(productRecommendationComponent);
        }catch(e){}
        let is_subscription_exist = false;
      
        window.globalVariables.cart.items.forEach(i=>{
          if(i.selling_plan_allocation){
            is_subscription_exist = true;
          }
        });
        if(is_subscription_exist == true && document.querySelector("[data-left-amount]") != null){
          
          document.querySelector("[data-left-amount]").innerHTML = `Your order qualifies for FREE shipping!`
        }
        is_subscription_exist = false;

       if (window.globalVariables.template =='product') {
        if(document.querySelectorAll("[data-free-trial]").length > 0){   
            if(totalPrice > freeTrial){
              document.querySelector("[data-free-trial]").classList.remove("d-none");
              document.querySelector("[data-free-shipping]").classList.add("d-none");
            }else if(totalPrice > freeShipping){
              document.querySelector("[data-free-shipping]").classList.remove("d-none");
              document.querySelector("[data-free-trial]").classList.add("d-none");

            }else{
              document.querySelector("[data-free-shipping]").classList.add("d-none");
              document.querySelector("[data-free-trial]").classList.add("d-none");
            };
        }
       }
      // this._checkGiftProduct();

    }

  manageComKit(){
    let totalGiftProduct = 0;
    window.globalVariables.cart.items.forEach(cartItem => {
      if( cartItem.properties['_isComplimentary'] == 'true' ){
        totalGiftProduct = totalGiftProduct + 1;
        if (cartItem.quantity > 1) {
          this._updateGWP(cartItem.id , 1)
          
        }
        if(totalGiftProduct > 3){
          this._updateGWP(cartItem.id , 0);
        }
      }
    });
    
      let totalPrice =  Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
      totalPrice = totalPrice.replace("$","");
      totalPrice = totalPrice.replace("£","");
      totalPrice = totalPrice.replace("€","");
      totalPrice = parseInt(totalPrice);
      let isComplementryExist = document.querySelectorAll("[data-complimentary-wrap]").length;
      let freeKitValue = parseInt(window.globalVariables.cart_value_for_kit);
      if(document.querySelector('.box-content .message-empty')){
        document.querySelector('.box-content .message-empty').classList.add("d-none");
      }
      if (totalPrice < freeKitValue){
       if (isComplementryExist > 0) {
        document.querySelector("[data-complimentary-wrap]").classList.add("d-none");
       }  
        this._removeFreeProduct();
        if(document.querySelector('.box-content .message-empty')){
          document.querySelector('.box-content .message-empty').classList.remove("d-none");
          document.querySelector('.box-content .message-empty .money-left').innerHTML = `$${freeKitValue - totalPrice}`;
        }
      }else if(totalPrice > freeKitValue) {
        if (isComplementryExist > 0) {  document.querySelector("[data-complimentary-wrap]").classList.remove("d-none");  } 
        const complimentaryButtons = document.querySelectorAll("[data-comkit-btn]");
        complimentaryButtons.forEach(button => {
            const buttonParent = button.closest("[data-comkit-handle]");
            const productHandle = buttonParent.getAttribute("data-comkit-handle");
    
            const isAlreadyAdded = window.globalVariables.cart.items.some(item => item.handle === productHandle);
            if (totalGiftProduct >= 3 || isAlreadyAdded) {
                button.classList.add("disabled");
                button.querySelector("[data-comkit-btn-text]").innerHTML = isAlreadyAdded ? "Added" : "Limit Reached";
            } else {
                button.classList.remove("disabled");
                button.querySelector("[data-comkit-btn-text]").innerHTML = "Add Free";
            }
        });
      }
  };

   _checkGiftProduct(){
    let cartRoute = `${routes.cart_fetch_url}?sections=gwp_pwp,header`;
     if (window.globalVariables.cart.total_price == 0 && window.globalVariables.cart.items > 0) {
      window.globalVariables.cart.items.forEach(i=>{
        this._updateGWP(i.id ,0);
      })
    }
   
    fetch(cartRoute).then(response => {
      return response.json();
    }).then(response => {
      let giftHTML = '';
      giftHTML = response['gwp_pwp'];
      if(giftHTML == null) return;
      let parser = new DOMParser();
      giftHTML = parser.parseFromString(giftHTML, 'text/html');
       if (giftHTML.querySelectorAll("[data_extra_product]").length > 0) {
        giftHTML.querySelectorAll("[data_extra_product]").forEach(extraProduct=>{
           let expiredGift = JSON.parse(extraProduct.innerText)[0];
           window.globalVariables.cart.items.forEach(k=>{
            if( k.id == expiredGift.gwp_pro){
              this._updateGWP(expiredGift.gwp_pro , 0)
            } 
           })
        })
      }
      let giftJSONEle = giftHTML.querySelectorAll('[data_collection_total]');
      giftJSONEle.forEach(ele=>{
        let giftRule = JSON.parse(ele.innerText)[0];
        let cartTotal = parseFloat(giftRule.cart_total);
        let minTotal = parseFloat(giftRule.min_total);
        let maxTotal = parseFloat(giftRule.max_total);
       
        if(giftRule.is_gift_exist == 'false' && cartTotal >= minTotal && cartTotal < maxTotal && giftRule.gwp_pro != null)
        {
          this._addGWP(giftRule.gwp_pro);
        }else if(giftRule.is_gift_exist == 'true' && cartTotal >= minTotal && cartTotal < maxTotal && giftRule.update_gift == true){
          this._updateGWP(giftRule.gwp_pro,1);
        }
        else if(giftRule.is_gift_exist == 'true' && (cartTotal >= maxTotal || cartTotal < minTotal))
       {
          this._updateGWP(giftRule.gwp_pro,0);
        }
      })
     
        // this._updateCart(response, action);
    }).catch((e) => {
        console.error(e);
    }).finally(() => {
        // Cart HTML fetch done
    });
  }

  _updateGWP(id , qty){
     var items = []
     let requestData = {}
     requestData[id] = qty;
     const body = JSON.stringify({
      updates : requestData
     });
     fetch(`/cart/update.js`, {
         method: 'POST',
         headers: {
             'Content-Type': 'application/json'
         },
         body: body
     })
     .then(async data => {
        this.getCartData();
     }).catch(e => {
      
     });
   }




  async _addGWP(id){
    var items = []
     let giftProperty = {};
     let vid = parseInt(id);
     let flag = false;
     window.globalVariables.cart.items.forEach(item=>{
      if (item.id == vid) {
        flag == true;
      }
     })
 giftProperty['_GWP']='true';
    if (id != null) {
      items.push( {
        quantity: 1,
        id: parseInt(id),
        properties : giftProperty
      });
    }
    const body = JSON.stringify({
    items: items
    });
if(flag == false){
 
    fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    })
    .then(async data => {
     
      await this.getCartData();
    }).catch(e => {
     
    });
  }
  }

// removefree product
  _removeFreeProduct(){
     window.globalVariables.cart.items.forEach((i,v)=>{
      v = v + 1;
      if (i.line_price == 0 && (i.properties['_isComplimentary'] == 'true')) {
        this.updateItemQty(v, 0);
      }
     })
  }

    /**
     * Fetch latest cart data 
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action){
        let cartRoute = `${routes.cart_fetch_url}?sections=header,template-cart`;
        if(window.globalVariables.template != 'cart'){
          cartRoute = `${routes.cart_fetch_url}?sections=header,template-cart-drawer`;
        }

        fetch(cartRoute).then(response => {
          return response.json();
        }).then(response => {
            this._updateCart(response, action);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            // Cart HTML fetch done
        });
    }
  
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
        let lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

        if(lineItem){ lineItem.classList.add('updating'); }
        const body = JSON.stringify({
            line,
            quantity
        });
  
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
        .then((response) => {
            // return response.text();
        })
        .then((_state) => {
          this.getCartData();
          setTimeout(() => {
            if(lineItem){ lineItem.classList.remove('updating'); }
          }, 1000);
          const productRecommendationComponent = document.querySelector('.cart-recommendations .product-recommendations');
          try{
            loadRecommendedProducts(productRecommendationComponent);
          }catch(e){}
        }).catch((error) => {
          setTimeout(() => {
            if(lineItem){ lineItem.classList.remove('updating'); }
          }, 1000);
          aog(error);
        });
    }
  
    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removeItem(event){
      event.preventDefault();
      if (window.globalVariables.template == "cart") {
        let currentEle = event.currentTarget;
        window.globalVariables.recently_remove_variant = parseInt(currentEle.getAttribute('vriant-id'));
        window.globalVariables.recently_remove_variant_title = currentEle.getAttribute('variant-title');

          document.querySelectorAll("[data-comkit-handle]").forEach(ele=>{
          let comkitAddBtn = ele.querySelector("[ data-comkit-btn]");
          if (ele.querySelector("[data-comkit-btn-text]").innerHTML !='Sold out') {
            comkitAddBtn.classList.remove("disabled");
            ele.querySelector("[data-comkit-btn-text]").innerHTML="Add Free";
            ele.querySelector("[data-comkit-btn]").classList.remove("free_added");
          }
        })
       
        
       if(window.globalVariables.recently_remove_variant !=null){
        document.querySelector("[recently-remove-title]").innerHTML = window.globalVariables.recently_remove_variant_title;
        document.querySelector("[data-recenty-remove-wrap]").classList.remove("d-none");
       } else{
        document.querySelector("[data-recenty-remove-wrap]").classList.remove("d-none");
       }
      }
      
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      if(itemIndex != null){
          this.updateItemQty(itemIndex, 0);
      }
    }
  
    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;
      let currentQty = parseInt($qtyInput.value) || 1;
      let finalQty = 1;
  
      if(action == 'decrease' && currentQty <= 1){
          return false;
      }else if(action == 'decrease'){
          finalQty = currentQty - 1;
      }else{
          finalQty = currentQty + 1;
      }
      this.updateItemQty(itemIndex, finalQty);
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event){
      const $qtyInput = event.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;
      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }

    /**
     * Manage Cart Notes
     */
    cartNoteInput(){
      const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
      if(!cartNoteEle) return;

      const cartNoteSave = document.querySelector('[data-saveNote]');
      let cartNoteEvents = ['input', 'paste'];
      cartNoteEvents.forEach((eventName)=>{
        cartNoteEle.addEventListener( eventName, ()=> {
          const defaultNote = cartNoteEle.dataset.default;
          if(defaultNote != cartNoteEle.value){
              cartNoteSave.style.display = 'block';
          }else{
              cartNoteSave.style.display = 'none';
          }
        }, false);
      });

      //  Cart Note Change event
      cartNoteSave.addEventListener( "click", e => {
        e.preventDefault();
        const currentTarget = e.currentTarget;
        const cartNoteContainer = currentTarget.closest('[data-cartNote]');
        const cartNote = cartNoteContainer.querySelector('[name="note"]').value.trim();
        if(cartNote.length <= 0){
          alert('Add Note before proceeding');
          return;
        }
        const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
        const waitText = (submitBtn.dataset.adding_txt) ? submitBtn.dataset.adding_txt : 'Saving...';
        submitBtn.innerHTML = waitText;
        submitBtn.disabled = true;
        this.updateCartNote(cartNoteContainer);
      });
    }

    /**
     * Update Cart Note
     * @param {element} cartNoteContainer 
     */
    updateCartNote(cartNoteContainer){
      const _this = this;
      const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
      const cartNote = cartNoteEle.value.trim();
      const resultEle = cartNoteContainer.querySelector('[data-resultMsg]');
      const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
      const defaultText = (submitBtn.dataset.default) ? submitBtn.dataset.default : 'Save';

      let body = JSON.stringify({
        note: cartNote
      });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }
      }).then(function (data) {
        if (data.status == 200) {
          if(resultEle){
            resultEle.innerText = 'Added note to Order!';
            _this.manageResponseText(resultEle);
          }
          if(cartNoteEle){
            cartNoteEle.dataset.default = cartNote;
          }
          submitBtn.style.display = 'none';
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
        else {
          console.error('Request returned an error', data);
          if(resultEle){
            resultEle.innerText = data;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
      }).catch(function (error) {
          console.error('Request failed', error);
          if(resultEle){
            resultEle.innerText = error;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
      });
    }

    /**
     * fade effect on reponse
     * @param {element} element 
     */
    manageResponseText(element){
      Utility.fadeEffect(element, 'fadeIn');
      setTimeout(() => {
          Utility.fadeEffect(element, 'fadeOut');
      }, 3000);
    }
}
customElements.define("ajax-cart", AjaxCart);
